/**
 * Asynchronously loads the component for TemplateGenerationSettingsComponent
 */

import { lazyLoad } from 'utils/loadable';

export const TemplateGenerationSettingsComponent = lazyLoad(
  () => import('./index'),
  module => module.TemplateGenerationSettingsComponent,
);
